import {
  genPageTheme,
  shapes,
  UnifiedThemeOptions,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';

/**
 * `unifiedLightPageTheme` object configures unique themes for various page categories.
 * Each entry specifies gradient colors and a shape for the page header,
 * enhancing the visual experience and differentiating sections of the app.
 *
 * Themes:
 * - Colors: Array defining gradient colors for the header.
 * - Shape: Specific header background shape for each theme.
 *
 * @category Theming
 */
export const unifiedLightPageTheme: UnifiedThemeOptions['pageTheme'] = {
  // Home page theme: Uses 'wave' shape with a gradient of aqua blue and dark gray
  home: genPageTheme({ colors: ['#00B8D4', '#212121'], shape: shapes.wave }),

  // Documentation page theme: Differentiates with 'wave2' shape for visual contrast
  documentation: genPageTheme({
    colors: ['#00B8D4', '#212121'],
    shape: shapes.wave2,
  }),

  // Tool page theme: Rounded shape gives tools a distinct visual identity
  tool: genPageTheme({ colors: ['#00B8D4', '#212121'], shape: shapes.round }),

  // Service page theme: Reuses 'wave' shape for consistency with main sections
  service: genPageTheme({
    colors: ['#00B8D4', '#212121'],
    shape: shapes.wave,
  }),

  // Website page theme: 'Wave' shape aligns visually with home and service pages
  website: genPageTheme({
    colors: ['#00B8D4', '#212121'],
    shape: shapes.wave,
  }),

  // Library page theme: 'Wave' shape provides consistency across major sections
  library: genPageTheme({
    colors: ['#00B8D4', '#212121'],
    shape: shapes.wave,
  }),

  // Other page theme: General-purpose theme for miscellaneous pages, using 'wave'
  other: genPageTheme({ colors: ['#00B8D4', '#212121'], shape: shapes.wave }),

  // App section theme: Maintains a 'wave' shape for coherence with main app pages
  app: genPageTheme({ colors: ['#00B8D4', '#212121'], shape: shapes.wave }),

  // API pages theme: Also adopts 'wave' to align with other core sections
  apis: genPageTheme({ colors: ['#00B8D4', '#212121'], shape: shapes.wave }),
};
